export function isFunction(maybeFn: any): maybeFn is (...args: any[]) => any {
  return typeof maybeFn == 'function';
}
